import React from "react";
import "../../Styles/certified/hakuna.css";

export default function Finzly() {
  return (
    <>
      <div className="hakuna-certified-details-section">
        <div className="hakuna-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="hakuna-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="hakuna-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="hakuna-certified-badge"
            />
            <div className="hakuna-certified-company-names">
              <a href="https://www.hakunamatatatech.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/hakuna/hakuna_logo.png"
                alt="Walkzero Logo"
                className="hakuna-certified-company-logo"
              />
            </a>
              <h1 className="hakuna-certified-full-name">
               Hakuna Matata Solutions Pvt Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="hakuna-certified-details-right">
            <img
              src="/assets/hakuna/hakuna_4.jpg"
              alt="Finzly Office"
              className="hakuna-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="hakuna-certified-description">
          <h2>
            Why Hakuna Matata Solutions Pvt Ltd is an Outstanding Workplaces
          </h2>
          <p>
           Hakuna Matata Solutions Pvt. Ltd. is a leading IT services and consulting company specializing in software development, digital transformation, product engineering, mobile and web application development, cloud solutions, and staffing services. The company partners with clients across various industries to deliver innovative technology solutions, high-quality software products, and skilled talent to support business growth and operational excellence.

          </p>
        </div>
        {/* Info Cards Section */}
        <div className="hakuna-certified-info-cards">
          <div className="hakuna-certified-info-card">
            <div className="hakuna-certified-info-title">COMPANY SIZE</div>
            <div className="hakuna-certified-info-value"> 50 Employees</div>
          </div>
          <div className="hakuna-certified-info-card">
            <div className="hakuna-certified-info-title">INDUSTRY</div>
            <div className="hakuna-certified-info-value">Information Technology (IT) Services & Consulting 

</div>
          </div>
          <div className="hakuna-certified-info-card">
            <div className="hakuna-certified-info-title">CONNECT</div>
            <div className="hakuna-certified-info-icons">
              <span className="hakuna-certified-icon-round">
                <a href="https://www.hakunamatatatech.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="hakuna-certified-icon-round">
                <a href="https://www.linkedin.com/company/hakuna-matata-solutions-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="hakuna-certified-icon-round">
                <a href="https://www.facebook.com/hakunamatatasolutions/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="hakuna-certified-info-card">
            <div className="hakuna-certified-info-title">LOCATION (HQ)</div>
            <div className="hakuna-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="hakuna-certified-recognition-section">
          <h2 className="hakuna-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="hakuna-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="hakuna-certified-recognition-image"
            />
          </div>
          <div className="hakuna-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="hakuna-certified-life-section">
          <h2 className="hakuna-certified-life-title">
            Life at Hakuna Matata Solutions Pvt Ltd 
          </h2>
          <div className="hakuna-certified-life-gallery">
            <div className="hakuna-certified-life-col">
              <img src="/assets/hakuna/hakuna_1.jpg" alt="Office 1" className="hakuna-certified-life-img" />
              <img src="/assets/hakuna/hakuna_2.jpg" alt="Team 1" className="hakuna-certified-life-img" />
            </div>
            <div className="hakuna-certified-life-col hakuna-certified-life-center">
              <img src="/assets/hakuna/hakuna_3.jpg" alt="Main Office" className="hakuna-certified-life-img hakuna-certified-life-img-large" />
            </div>
            <div className="hakuna-certified-life-col">
              <img src="/assets/hakuna/hakuna_4.jpg" alt="Office 2" className="hakuna-certified-life-img" />
              <img src="/assets/hakuna/hakuna_5.jpg" alt="Team 2" className="hakuna-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
